var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMsgIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Component 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/messages"
  }, /*#__PURE__*/React.createElement("g", {
    id: "messages"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20.9766 12.5883V17.255C20.9766 17.5583 20.9649 17.85 20.9299 18.13C20.6616 21.28 18.8066 22.8433 15.3883 22.8433H14.9216C14.6299 22.8433 14.3499 22.9833 14.1749 23.2167L12.7749 25.0833C12.1566 25.9117 11.1533 25.9117 10.5349 25.0833L9.1349 23.2167C8.98324 23.0183 8.64492 22.8433 8.38825 22.8433H7.9216C4.19993 22.8433 2.33325 21.9217 2.33325 17.255V12.5883C2.33325 9.17001 3.90826 7.31501 7.0466 7.04668C7.3266 7.01168 7.61826 7 7.9216 7H15.3883C19.1099 7 20.9766 8.86668 20.9766 12.5883Z",
    stroke: "#00AB55",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M25.6433 7.92184V12.5885C25.6433 16.0185 24.0683 17.8618 20.93 18.1302C20.965 17.8502 20.9766 17.5585 20.9766 17.2552V12.5885C20.9766 8.86684 19.11 7.00016 15.3883 7.00016H7.92163C7.6183 7.00016 7.32663 7.01184 7.04663 7.04684C7.31496 3.90851 9.16996 2.3335 12.5883 2.3335H20.055C23.7766 2.3335 25.6433 4.20017 25.6433 7.92184Z",
    stroke: "#00AB55",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M15.7448 15.4583H15.7553",
    stroke: "#00AB55",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M11.6613 15.4583H11.6718",
    stroke: "#00AB55",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M7.57808 15.4583H7.58858",
    stroke: "#00AB55",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMsgIcon);
export default __webpack_public_path__ + "static/media/msg-icon.bc2c577c5d41f0d214dec1f5aa360a4e.svg";
export { ForwardRef as ReactComponent };